import React from 'react';

import Table from 'components/Table';
import type { PackageUtilizationExpectationListItem } from 'types';

import columns from './columns';
import NoExpectationsFound from './NoExpectationsFound';

type ExpectationsTableProps = {
  data: PackageUtilizationExpectationListItem[];
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
};

const ExpectationsTable = ({ data, isLoading, isSuccess, isError }: ExpectationsTableProps): JSX.Element => {
  return (
    <Table
      tableData={data}
      columns={columns}
      isLoading={isLoading}
      isSuccess={isSuccess}
      isError={isError}
      EmptyState={<NoExpectationsFound />}
    />
  );
};

export default ExpectationsTable;
